import React from 'react';

import { StoreApplicant } from '@funnels/types';

import Accordion from '../../../../Layouts/_common/Accordion';
import AddressHeader from '../../Base/AccordionHeader';
import { ThreeYearsDate } from '../../types';
import CopyFromOtherApplicants from '../CopyFromOtherApplicants';
import { useAddressData } from './hooks';

interface AccordionContentProps {
  children: (
    addressFieldLabel: string,
    addressFieldName: string,
    addressFieldPath: string,
    housingStatusFieldLabel: string,
    housingStatusFieldName: string,
    startDate: ThreeYearsDate,
    endDate?: ThreeYearsDate,
    mailingAddressFieldLabel?: string,
    mailingAddressFieldPath?: string,
    mailingAddressFieldName?: string
  ) => React.ReactNode;
  index: number;
  applicantIndex: number;
  otherApplicants: StoreApplicant[];
  isCustomerApplicant: boolean;
  onDelete: (text?: string) => void;
  hideCopyLink?: boolean;
}

function AccordionContent(props: AccordionContentProps) {
  const { index, applicantIndex, otherApplicants, isCustomerApplicant, hideCopyLink } = props;
  const {
    headerData,
    addressFieldLabel,
    addressFieldName,
    addressFieldPath,
    housingStatusFieldLabel,
    housingStatusFieldName,
    mailingAddressFieldLabel,
    mailingAddressFieldPath,
    mailingAddressFieldName,
    startDate,
    endDate,
  } = useAddressData(applicantIndex, index, isCustomerApplicant);
  const onDelete = index > 0 ? props.onDelete : undefined;

  function header(isOpen: boolean) {
    const { addressFormatted, startDate, endDate, isCurrent } = headerData;
    const defaultText = isCurrent ? 'Current residence' : 'Previous residence';

    return (
      <AddressHeader
        isOpen={isOpen}
        text={addressFormatted}
        defaultText={defaultText}
        startDate={startDate}
        endDate={endDate}
        isCurrent={isCurrent}
      />
    );
  }

  return (
    <Accordion.Item header={header} onDelete={onDelete}>
      {!hideCopyLink && (
        <CopyFromOtherApplicants list={otherApplicants} applicantIndex={applicantIndex} addressIndex={index} />
      )}
      {props.children(
        addressFieldLabel,
        addressFieldName,
        addressFieldPath,
        housingStatusFieldLabel,
        housingStatusFieldName,
        startDate,
        endDate,
        mailingAddressFieldLabel,
        mailingAddressFieldPath,
        mailingAddressFieldName
      )}
    </Accordion.Item>
  );
}

export default AccordionContent;
